import { Button } from "../../components/Button";
import { Col, Container, Row } from "react-grid-system";
import { Sidemenu } from "../../components/Sidemenu";
import { STabs, STabList, STab, STabPanel } from "../../styles/Tabs";
import { StyledPageHeader } from "../../styles/StyledPage";
import { useQuery } from "react-query";
import AddIcon from "../../assets/img/icons/add.svg";
import CalendarIcon from "../../assets/img/icons/calendar.svg";
import { Link } from "react-router-dom";
import { useAppContext } from "../../context/appContext";
import moment from "moment";
import { QueryLoader } from "../../components/Loader";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useState, useEffect } from "react";
import { SearchFilters } from "../../components/SearchFilters";
import { getSearchResult } from "../../api/search/search";
import { useSearchContext } from "../../context/search";
import { DecisionList } from "../../components/DecisionList/DecisionList";
import { DocumentUploadModal } from "../../components/DocumentUpload";
import UploadIcon from "../../assets/img/icons/upload.svg";

export default function DashboardPage() {
	const { items } = useAppContext();
	const {
		state: { filters },
	} = useSearchContext();
	const { axiosPrivate } = useAxiosPrivate();
	const { isLoading, isError, error, data } = useQuery(["decisionsList", filters], () =>
		getSearchResult(axiosPrivate, undefined, false, filters)
	);
	const [currentUserId, setCurrentUserId] = useState(null);
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
	const canSee = (decision) => {
		if (items.userUnits[decision.unit.id]) return true;
		if (
		Array.isArray(decision.receiverUnits) &&
		decision.receiverUnits.some((u) => items.userUnits[u.id])
		) {
		return true;
		}
		return false;
  	};
	const safeData = Array.isArray(data) ? data : [];
	const tabs = {
		ongoing: safeData.filter((d) => {
			return (
				d.status.slug === "ongoing" &&
				canSee(d) &&
				d.createdBy === currentUserId
			);
	}),
		done: safeData.filter(
			(d) =>
				d.status.slug === "done" &&
				canSee(d) &&
				String(d.createdBy?.id) === String(currentUserId)
		),
		archive: safeData.filter(
			(d) =>
				d.status.slug === "archive" &&
				canSee(d) &&
				String(d.createdBy?.id) === String(currentUserId)
		),
	};

	useEffect(() => {
		if (isError) console.log(error);
	}, [isError]);

	useEffect(() => {
		const fetchUser = async () => {
			try {
				const res = await axiosPrivate.get("/user/profile.json");
				setCurrentUserId(res.data.id);
			} catch (err) {
				console.error("Failed to fetch user profile", err);
			}
		};
		fetchUser();
	}, []);

	const handleUploadModalClose = () => {
		setIsUploadModalOpen(false);
	};

	const handleDecisionCreated = (decisionData) => {
		// This could trigger a refetch of decisions if needed
		console.log("Decision created from document:", decisionData);
	};

	return (
		<Container>
			<Row style={{ marginTop: "2rem" }}>
				<Col sm={12} lg={2}>
					<Sidemenu />
					<SearchFilters />
				</Col>
				<Col sm={12} lg={10}>
					<StyledPageHeader>
						<div>
							<i>
								<img src={CalendarIcon} alt="Date" />
							</i>
							<span>{`${moment(new Date()).format("YYYY-MM-DD")}`}</span>
						</div>
					</StyledPageHeader>

					<StyledPageHeader>
						<h2>Decisions</h2>
						<div style={{ display: "flex", gap: "1rem" }}>
							<Button 
								icon={UploadIcon} 
								onClick={() => setIsUploadModalOpen(true)}
								bg={true}
								initial={true}
							>
								Upload Document
							</Button>
							{/* {Object.keys(items.userUnits).length !== 0 && (
								<Link to={"/add-decision"}>
									<Button icon={AddIcon}>Add new decision</Button>
								</Link>
							)} */}
						</div>
					</StyledPageHeader>
					{isLoading ? (
						<QueryLoader />
					) : isError ? (
						`An error occured, please reload the page - ${error}`
					) : (
						Array.isArray(data) && (
							<STabs selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected">
								<STabList>
									<STab>Ongoing</STab>
									<STab>Done</STab>
									<STab>Archive</STab>
								</STabList>
								<STabPanel>
									<DecisionList clearSearchResults={true} data={tabs.ongoing} />
								</STabPanel>
								<STabPanel>
									<DecisionList clearSearchResults={true} data={tabs.done} />
								</STabPanel>
								<STabPanel>
									<DecisionList clearSearchResults={true} data={tabs.archive} />
								</STabPanel>
							</STabs>
						)
					)}
				</Col>
			</Row>
			
			<DocumentUploadModal 
				isOpen={isUploadModalOpen}
				onClose={handleUploadModalClose}
				onDecisionCreated={handleDecisionCreated}
			/>
		</Container>
	);
}
